import React, { Suspense } from "react";
import { Routes, Route, Navigate, Outlet } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useEffect } from "react";
import Loader from "../components/Loader/Loader";
import { publicRoutes } from "./publicRoutes";
import { b2bRoutes, gcbRoutes } from "./b2bRoutes";
import { adminRoutes } from "./adminRoutes";

/**
 * Language gate component for handling language routing
 */
function LangGate({ lang }) {
  const { i18n } = useTranslation();
  useEffect(() => {
    if (i18n.language !== lang) {
      i18n.changeLanguage(lang);
    }
  }, [lang, i18n]);
  return <Outlet />;
}

/**
 * Main application router
 * Combines all route configurations into a single component
 */
const AppRouter = () => {
  return (
    <Suspense fallback={<Loader />}>
      <Routes>
        {/* Public Routes */}
        {publicRoutes.map((route) => (
          <Route
            key={route.path}
            path={route.path}
            element={route.element}
          />
        ))}

        {/* B2B Routes */}
        {b2bRoutes.map((route) => (
          <Route
            key={route.path}
            path={route.path}
            element={route.element}
          />
        ))}
        {gcbRoutes.map((route) => (
          <Route
            key={route.path}
            path={route.path}
            element={route.element}
          />
        ))}

        {/* Admin Routes */}
        {adminRoutes.map((route) => (
          <Route
            key={route.path}
            path={route.path}
            element={route.element}
          />
        ))}

        {/* Russian Language Routes */}
        <Route
          path="/ru/*"
          element={<LangGate lang="ru" />}
        >
          {/* Duplicate all routes for Russian */}
          {publicRoutes.map((route) => (
            <Route
              key={`ru-${route.path}`}
              path={
                route.path === "/"
                  ? ""
                  : route.path.startsWith("/")
                    ? route.path.slice(1)
                    : route.path
              }
              element={route.element}
            />
          ))}
          {b2bRoutes.map((route) => (
            <Route
              key={`ru-${route.path}`}
              path={
                route.path.startsWith("/") ? route.path.slice(1) : route.path
              }
              element={route.element}
            />
          ))}
          {gcbRoutes.map((route) => (
            <Route
              key={`ru-${route.path}`}
              path={
                route.path.startsWith("/") ? route.path.slice(1) : route.path
              }
              element={route.element}
            />
          ))}
          {adminRoutes.map((route) => (
            <Route
              key={`ru-${route.path}`}
              path={
                route.path.startsWith("/") ? route.path.slice(1) : route.path
              }
              element={route.element}
            />
          ))}
        </Route>

        {/* Catch-all redirect */}
        <Route
          path="*"
          element={
            <Navigate
              to="/"
              replace
            />
          }
        />
      </Routes>
    </Suspense>
  );
};

export default AppRouter;
